function INIT_FILTER_OPTIONS(filterElement) {
    const ENABLED_FILTER_OPTIONS = filterElement.querySelectorAll('[data-filter-name]:not(.disabled)');

    ENABLED_FILTER_OPTIONS.forEach(filterOption => {
        filterOption.addEventListener('click', () => {

            const IS_ACTIVE = filterOption.getAttribute('data-active') !== null;

            if (!IS_ACTIVE) {
                const OPTION_NAME = filterOption.getAttribute('data-filter-name');
                const OPTION_LIST = document.querySelector(`[data-list-name="${OPTION_NAME}"]`);

                const ACTIVE_LIST = document.querySelector('[data-list-name][data-active]');
                const ACTIVE_OPTION = document.querySelector('[data-filter-name][data-active]');

                ACTIVE_OPTION.removeAttribute('data-active');
                ACTIVE_LIST.removeAttribute('data-active');

                filterOption.setAttribute('data-active', '');
                OPTION_LIST.setAttribute('data-active', '');

            }
        })
    })
}

export function INIT_SEARCH_FILTER(filterElement) {
    INIT_FILTER_OPTIONS(filterElement)
}
